<!-- Global Call Panel - Floating draggable component -->
<div
  *ngIf="isVisible()"
  class="global-call-panel"
  [class.minimized]="isMinimized()"
  [class.expanded]="!isMinimized()"
  [class.call-active]="isCallActive()"
  [style.left.px]="effectivePosition().left"
  [style.top.px]="effectivePosition().top"
  cdkDrag
  (cdkDragEnded)="onDragEnded($event)">

  <!-- ========================================================================
       MINIMIZED VIEW - Compact badge
       ======================================================================== -->
  <div *ngIf="isMinimized()" class="minimized-view" (click)="expandPanel()">
    <div class="minimized-content">
      <!-- Pulsing indicator -->
      <div class="pulse-indicator" *ngIf="isCallActive()"></div>

      <!-- Call icon -->
      <mat-icon class="minimized-icon">{{ callStateIcon() }}</mat-icon>

      <!-- Duration -->
      <span class="minimized-duration">{{ formattedDuration() }}</span>

      <!-- Expand hint icon -->
      <mat-icon class="expand-icon">unfold_more</mat-icon>
    </div>
  </div>

  <!-- ========================================================================
       EXPANDED VIEW - Full call interface
       ======================================================================== -->
  <div *ngIf="!isMinimized()" class="expanded-view">
    <!-- Header with drag handle and controls -->
    <div class="panel-header" cdkDragHandle>
      <div class="drag-handle">
        <mat-icon class="drag-icon">drag_indicator</mat-icon>
        <span class="panel-title">Active Call</span>
      </div>

      <div class="header-controls">
        <!-- Minimize button -->
        <button
          mat-icon-button
          class="header-button"
          (click)="toggleMinimize()"
          matTooltip="Minimize"
          aria-label="Minimize panel">
          <mat-icon>minimize</mat-icon>
        </button>
        <!-- Close button -->
        <button
          mat-icon-button
          class="header-button close-button"
          (click)="closePanel()"
          matTooltip="End Call"
          aria-label="End call">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <!-- Lead Information -->
    <div class="lead-info">
      <!-- Avatar with initials -->
      <div class="lead-avatar">
        <span class="avatar-text">{{ leadInitials() }}</span>
      </div>

      <!-- Lead details -->
      <div class="lead-details">
        <div class="lead-name-row">
          <span class="lead-name">{{ leadName() }}</span>
          <button
            *ngIf="leadId()"
            mat-icon-button
            class="view-lead-button"
            (click)="goToLead()"
            matTooltip="View Lead"
            aria-label="View lead details">
            <mat-icon>open_in_new</mat-icon>
          </button>
        </div>
        <div class="lead-phone">{{ phoneNumber() }}</div>
      </div>

      <!-- Direction badge -->
      <div
        class="direction-badge"
        [class.inbound]="direction() === 'inbound'"
        [class.outbound]="direction() === 'outbound'"
        *ngIf="direction()">
        <mat-icon class="direction-icon">{{ directionIcon() }}</mat-icon>
        <span class="direction-text">{{ directionText() }}</span>
      </div>
    </div>

    <!-- Call State and Duration -->
    <div class="call-state-section">
      <!-- State indicator -->
      <div class="state-indicator">
        <mat-icon
          class="state-icon"
          [class.pulse]="['dialing', 'ringing'].includes(currentState())">
          {{ callStateIcon() }}
        </mat-icon>
        <span class="state-label">{{ callStateLabel() }}</span>
      </div>

      <!-- Duration timer -->
      <div class="duration-display" *ngIf="callDuration() > 0">
        <mat-icon class="timer-icon">timer</mat-icon>
        <span class="duration-text">{{ formattedDuration() }}</span>
      </div>
    </div>

    <!-- Connection Status -->
    <div class="connection-status" [class.connected]="isConnected()" [class.disconnected]="!isConnected()">
      <mat-icon class="status-icon">{{ isConnected() ? 'wifi' : 'wifi_off' }}</mat-icon>
      <span class="status-text">{{ isConnected() ? 'Connected' : 'Disconnected' }}</span>
    </div>

    <!-- Call Controls -->
    <div class="call-controls" *ngIf="currentState() === 'connected' || currentState() === 'held'">
      <!-- Mute button -->
      <button
        mat-mini-fab
        [color]="isMuted() ? 'warn' : 'default'"
        [disabled]="!canToggleMute()"
        (click)="toggleMute()"
        class="control-button mute-button"
        [matTooltip]="isMuted() ? 'Unmute' : 'Mute'"
        [attr.aria-label]="isMuted() ? 'Unmute call' : 'Mute call'">
        <mat-icon>{{ isMuted() ? 'mic_off' : 'mic' }}</mat-icon>
      </button>

      <!-- Hold button -->
      <button
        mat-mini-fab
        [color]="isOnHold() ? 'accent' : 'default'"
        [disabled]="!canToggleHold()"
        (click)="toggleHold()"
        class="control-button hold-button"
        [matTooltip]="isOnHold() ? 'Resume' : 'Hold'"
        [attr.aria-label]="isOnHold() ? 'Resume call' : 'Hold call'">
        <mat-icon>{{ isOnHold() ? 'play_arrow' : 'pause' }}</mat-icon>
      </button>

      <!-- End call button -->
      <button
        mat-mini-fab
        color="warn"
        (click)="endCall()"
        class="control-button end-button"
        matTooltip="End Call"
        aria-label="End call">
        <mat-icon>call_end</mat-icon>
      </button>
    </div>
  </div>
</div>
